import * as utils from "../components/Utils/Utils";
const pdfMake = require("pdfmake/build/pdfmake.js");
const pdfFonts = require("pdfmake/build/vfs_fonts.js");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const logo_img =
  "data:image/png;base64,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";

const default_style = {
  style_header: {
    alignment: "left",
    margin: [50, 40, 0, 0],
  },
  style_footer: {
    alignment: "right",
    margin: [0, 20, 20, 0],
  },
  title: {
    fontSize: 18,
    bold: true,
    margin: [0, 20, 20, 0],
    alignment: "center",
  },
  subtitle: {
    fontSize: 13,
    bold: true,
    alignment: "center",
  },
  tableHeader: {
    bold: true,
    fontSize: 10,
  },
  tableBody: {
    fontSize: 9,
  },
};

const makeDocument = (header, footer, content, style) => {
  let documentDefinition = {
    header: function (currentPage) {
      if (header != "") {
        return [
          {
            text: header,
            style: "style_header",
          },
        ];
      } else
        return {
          columns: [
            { width: 430, text: "" },
            {
              image: "logo",
              width: 30,
            },
            {
              stack: [
                {
                  text: "Dr. Jose Kuran",
                  fontSize: 9,
                },
                {
                  text: "Tel.",
                  fontSize: 9,
                },
                {
                  text: "Email:",
                  fontSize: 9,
                },
              ],
              width: "*",
            },
          ],
          margin: [15, 15],
        };
    },

    // table: {
    //     headerRows: 0,
    //     body: [
    //       [
    //         {
    //           image: "logo",
    //           width: 30,
    //         },
    //         [
    //           {
    //             text: ["Dr. Jose Kuran", "Telefono", "Email"],
    //             fontSize: 9,
    //           },
    //         ],
    //       ],
    //     ],
    //   },
    //      layout: "noBorders",
    //           margin: [0, 40, 10, 0],
    //           alignment: "right",
    footer: function (currentPage, pageCount) {
      return [
        {
          text:
            footer !== ""
              ? footer
              : "Pág. " + currentPage.toString() + " de " + pageCount,
          style: "style_footer",
        },
      ];
    },
    pageSize: "A4",
    pageMargins: [40, 60, 40, 60],
    defaultStyle: {
      fontSize: 11,
    },
    content: content,
    images: {
      logo: logo_img,
    },
    styles: {
      style_header: {
        alignment: "right",
        margin: [50, 40, 0, 0],
      },
      style_footer: {
        alignment: "right",
        margin: [0, 20, 20, 0],
      },
      title: {
        fontSize: 18,
        bold: true,
        margin: [0, 20, 20, 0],
        alignment: "center",
      },
      subtitle: {
        fontSize: 13,
        bold: true,
        alignment: "center",
      },
      tableHeader: {
        bold: true,
        fontSize: 10,
      },
      tableBody: {
        fontSize: 9,
      },
      ...style,
    },
  };

  pdfMake.createPdf(documentDefinition).open();
};

const commonData = (data_paciente, antecedentes, antecedentes_embarazo) => {
  let tabla_paciente = [
    {
      margin: [0, 5],
      fontSize: 10,
      columns: [
        {
          text: [
            { text: "Paciente: ", bold: true },
            { text: `${data_paciente.apellido}, ${data_paciente.nombres}` },
          ],
          alignment: "left",
        },
        {
          text: [
            { text: "Edad: ", bold: true },
            {
              text: `${
                new Date().getFullYear() -
                new Date(data_paciente.fecha_nacimiento).getFullYear()
              } años`,
            },
          ],
          alignment: "left",
        },
        {
          text: [
            { text: "Documento: ", bold: true },
            { text: data_paciente.documento ? data_paciente.documento : "-" },
          ],
          alignment: "left",
        },
        {
          text: [
            { text: "Grupo Sanguíneo: ", bold: true },
            {
              text: `${
                utils.grupo_sanguineo.filter((x) => {
                  return x.id === data_paciente.grupo_sanguineo;
                })[0].nombre
              }`,
            },
          ],
          alignment: "left",
        },
      ],
    },
    {
      margin: [0, 5],
      fontSize: 10,
      columns: [
        {
          text: [
            { text: "Domicilio: ", bold: true },
            {
              text: `${data_paciente.domicilio} ${
                data_paciente.localidad ? "- " + data_paciente.localidad : ""
              }`,
            },
          ],
          alignment: "left",
        },
        {
          text: [
            { text: "Teléfonos: ", bold: true },
            {
              text: `${data_paciente.telefono1} / ${data_paciente.telefono2}`,
            },
          ],
          alignment: "left",
        },
      ],
    },
    {
      margin: [0, 5],
      fontSize: 10,
      columns: [
        {
          text: [
            { text: "Obra Social: ", bold: true },
            {
              text: data_paciente.obra_social,
            },
          ],
          alignment: "left",
        },
        {
          text: [
            { text: "Nro Afiliado: ", bold: true },
            {
              text: data_paciente.obra_social_num,
            },
          ],
          alignment: "left",
        },
        {
          text: [
            { text: "TOKEN: ", bold: true },
            {
              text: data_paciente.obra_social_token,
            },
          ],
          alignment: "left",
        },
      ],
    },
    {
      margin: [0, 5],
      fontSize: 10,
      text: [
        { text: "Profesión: ", bold: true },
        { text: data_paciente.profesion },
      ],
      alignment: "left",
    },
  ];

  let ant_personales = [{ text: "No hay antecedentes", fontSize: 9 }];
  let ant_familiares = [{ text: "No hay antecedentes", fontSize: 9 }];

  if (antecedentes.length > 0) {
    ant_personales = antecedentes.filter((e) => {
      return e.valor && e.antecedente_tipo === "P";
    });

    if (ant_personales.length === 0)
      ant_personales = [{ text: "No hay antecedentes", fontSize: 9 }];
    else
      ant_personales = ant_personales.map((e) => {
        if (e.antecedente_nombre === "Otros")
          return {
            text: e.extra_descripcion,
            fontSize: 9,
          };
        else
          return {
            text:
              e.antecedente_nombre +
              (e.extra_descripcion !== "" ? ": " + e.extra_descripcion : "") +
              (e.extra_numerico ? ": " + e.extra_descripcion : ""),
            fontSize: 9,
          };
      });

    ant_familiares = antecedentes.filter((e) => {
      return e.valor && e.antecedente_tipo === "F";
    });

    if (ant_familiares.length === 0)
      ant_familiares = [{ text: "No hay antecedentes", fontSize: 9 }];
    else
      ant_familiares = ant_familiares.map((e) => {
        if (e.antecedente_nombre === "Otros")
          return {
            text: e.extra_descripcion,
            fontSize: 9,
          };
        else
          return {
            text:
              e.antecedente_nombre +
              (e.extra_descripcion !== "" ? ": " + e.extra_descripcion : "") +
              (e.extra_numerico ? ": " + e.extra_descripcion : ""),
            fontSize: 9,
          };
      });
  }

  let ant_embarazo = [{ text: "No hay antecedentes", fontSize: 9 }];

  if (antecedentes_embarazo.length > 0) {
    ant_embarazo = [
      {
        table: {
          headerRows: 1,
          widths: ["auto", "auto", "auto"],

          body: [
            [
              {
                text: "Gestas Totales: " + antecedentes_embarazo[0].gestas,
                align: "center",
                bold: true,
                fontSize: 9,
                colSpan: 3,
              },
              "",
              "",
            ],
            [
              {
                text: "Abortos: " + antecedentes_embarazo[0].abortos,
                fontSize: 9,
              },
              {
                text:
                  "P. Vaginales: " + antecedentes_embarazo[0].partos_vaginales,
                fontSize: 9,
              },
              {
                text:
                  "P. Cesareas: " + antecedentes_embarazo[0].partos_cesareas,
                fontSize: 9,
              },
            ],
          ],
        },
      },
      {
        margin: [0, 5],
        table: {
          headerRows: 1,
          widths: ["auto", "auto", "auto", "auto"],

          body: [
            [
              {
                text: "Partos Totales: " + antecedentes_embarazo[0].partos,
                align: "center",
                bold: true,
                fontSize: 9,
                colSpan: 4,
              },
              "",
              "",
              "",
            ],
            [
              {
                text:
                  "Nacidos Vivos: " + antecedentes_embarazo[0].nacidos_vivos,
                fontSize: 9,
                colSpan: 3,
              },
              "",
              "",
              {
                text:
                  "Nacidos Muertos: " +
                  antecedentes_embarazo[0].nacidos_muertos,
                fontSize: 9,
                rowSpan: 2,
              },
            ],
            [
              {
                text:
                  "Mueren > Semana 1: " +
                  antecedentes_embarazo[0].mueren_semana,
                fontSize: 9,
              },
              {
                text:
                  "Mueren < Semana 1: " +
                  antecedentes_embarazo[0].mueren_despues,
                fontSize: 9,
              },
              {
                text: "Viven: " + antecedentes_embarazo[0].viven,
                fontSize: 9,
              },
              "",
            ],
          ],
        },
      },
      {
        text: [
          {
            text: "Fecha Terminación Embarazo Anterior: ",
            bold: true,
            fontSize: 9,
          },
          {
            text: antecedentes_embarazo[0].fecha_terminacion_anterior
              ? utils.displayFecha(
                  utils.formatFecha(
                    antecedentes_embarazo[0].fecha_terminacion_anterior
                  )
                )
              : "-",
            fontSize: 9,
          },
        ],
      },
      {
        text: [
          { text: "Algún RN con peso < 2500G: ", bold: true, fontSize: 9 },
          {
            text:
              antecedentes_embarazo[0].algun_peso_menor !== null
                ? antecedentes_embarazo[0].algun_peso_menor
                  ? "SI"
                  : "NO"
                : "-",
            fontSize: 9,
          },
        ],
      },
      {
        text: [
          { text: "Nacimiento mayor peso: ", bold: true, fontSize: 9 },
          {
            text:
              antecedentes_embarazo[0].peso_mayor !== null
                ? antecedentes_embarazo[0].peso_mayor + " G"
                : "-",
            fontSize: 9,
          },
        ],
      },
    ];
  }

  let content = [
    tabla_paciente,
    {
      text: `Antecedentes`,
      fontSize: 13,
      bold: true,
      color: "#7987a1",
      alignment: "left",
      margin: [0, 10],
    },
    {
      table: {
        headerRows: 1,
        widths: ["auto", "auto", "auto"],
        body: [
          [
            { text: "Personales", bold: true },
            { text: "Familiares", bold: true },
            { text: "Obstétricos", bold: true },
          ],
          [ant_personales, ant_familiares, ant_embarazo],
        ],
      },
      layout: "noBorders",
    },
  ];

  return content;
};

const fichaObstetricia = (
  data_paciente,
  data_embarazo,
  number_embarazo,
  antecedentes,
  antecedentes_embarazo,
  callback
) => {
  let consultas_header = [
    {
      text: "FECHA",
      style: "tableHeader",
      alignment: "left",
    },
    {
      text: "SEMANA",
      style: "tableHeader",
      alignment: "center",
    },
    { text: "PESO (KG)", style: "tableHeader", alignment: "center" },
    {
      text: "TENSIÓN (MM HG)",
      style: "tableHeader",
      alignment: "center",
    },
    { text: "ALTURA (CM)", style: "tableHeader", alignment: "center" },
    { text: "PRESENTACIÓN", style: "tableHeader", alignment: "center" },
    { text: "FCF", style: "tableHeader", alignment: "center" },
    { text: "MOVIMIENTO", style: "tableHeader", alignment: "center" },
  ];

  let consultas = [];

  data_embarazo.consultas.forEach((element) => {
    consultas.push([
      {
        text: utils.displayFecha(element.fecha),
        style: "tableBody",
        rowSpan: 2,
      },
      { text: element.semana, style: "tableBody", alignment: "center" },
      { text: element.peso || "-", style: "tableBody", alignment: "center" },
      {
        text: `${element.tension_arterial_max || "-"} / ${
          element.tension_arterial_min || "-"
        }`,
        style: "tableBody",
        alignment: "center",
      },
      {
        text: element.altura_uterina || "-",
        style: "tableBody",
        alignment: "center",
      },
      {
        text:
          element.presentacion !== ""
            ? utils.presentaciones_embarazo.filter((x) => {
                return x.id === element.presentacion;
              })[0].nombre
            : "-",
        style: "tableBody",
        alignment: "center",
      },
      {
        text:
          element.fcf !== ""
            ? utils.fcf_embarazo.filter((x) => {
                return x.id === element.fcf;
              })[0].nombre
            : "-",
        style: "tableBody",
        alignment: "center",
      },
      {
        text:
          element.mov_fetal !== null ? (element.mov_fetal ? "SI" : "NO") : "-",
        style: "tableBody",
        alignment: "center",
      },
    ]);
    consultas.push([
      "",
      {
        text: [
          {
            text: "Observaciones: ",
            bold: true,
          },
          {
            text: element.observaciones ? element.observaciones : "-",
          },
        ],
        style: "tableBody",
        alignment: "left",
        colSpan: 6,
      },
      "",
      "",
      "",
      "",
      "",
      {
        text: [
          {
            text: "Medico: ",
            bold: true,
          },
          {
            text: element.medico
              ? "Dr. " + element.medico_apellido + ", " + element.medico_nombres
              : "-",
          },
        ],
        style: "tableBody",
        alignment: "left",
      },
    ]);
  });

  let tabla_embarazo = [
    {
      margin: [0, 5],
      fontSize: 10,
      columns: [
        {
          text: [
            { text: "Peso Anterior: ", bold: true, width: 100 },
            {
              text:
                data_embarazo.peso_anterior !== null
                  ? data_embarazo.peso_anterior + " Kg."
                  : "-",
            },
          ],
          alignment: "left",
        },
        {
          text: [
            { text: "Talla: ", bold: true },
            {
              text:
                data_embarazo.talla !== null
                  ? data_embarazo.talla + " CM"
                  : "-",
            },
          ],
          alignment: "left",
        },
        {
          text: [
            { text: "FUM: ", bold: true },
            { text: utils.displayFecha(utils.formatFecha(data_embarazo.fum)) },
          ],
          alignment: "left",
        },
        {
          text: [
            { text: "FPP: ", bold: true },
            { text: utils.displayFecha(utils.formatFecha(data_embarazo.fpp)) },
          ],
          alignment: "left",
        },
        {
          text: [
            { text: "Estado: ", bold: true },
            {
              text:
                data_embarazo.estado !== ""
                  ? utils.estados_embarazo.filter((x) => {
                      return x.id === data_embarazo.estado;
                    })[0].nombre
                  : "-",
            },
          ],
          alignment: "left",
        },
      ],
    },
    {
      margin: [0, 5],
      fontSize: 10,
      columns: [
        {
          text: [
            { text: "ATT Previa: ", bold: true },
            {
              text:
                data_embarazo.antitetanica !== null
                  ? data_embarazo.antitetanica
                    ? "SI"
                    : "NO"
                  : "-",
            },
          ],
          alignment: "left",
        },
        {
          text: [
            { text: "ATT Actual 1era: ", bold: true },
            {
              text:
                data_embarazo.antitetanica_actual_1 !== null
                  ? "mes " + data_embarazo.antitetanica_actual_1
                  : "-",
            },
          ],
          alignment: "left",
        },
        {
          text: [
            { text: "ATT Actual 2da: ", bold: true },
            {
              text:
                data_embarazo.antitetanica_actual_2 !== null
                  ? "mes " + data_embarazo.antitetanica_actual_2
                  : "-",
            },
          ],
          alignment: "left",
        },
        {
          text: [
            { text: "Sensibilidad RH: ", bold: true },
            {
              text:
                data_embarazo.sensibil_rh !== null
                  ? data_embarazo.sensibil_rh
                    ? "SI"
                    : "NO"
                  : "-",
            },
          ],
          alignment: "left",
        },
      ],
    },
    {
      margin: [0, 5],
      fontSize: 10,
      columns: [
        {
          text: [
            { text: "Exámen Mamas Normal: ", bold: true },
            {
              text:
                data_embarazo.examen_mama !== null
                  ? data_embarazo.examen_mama
                    ? "SI"
                    : "NO"
                  : "-",
            },
          ],
          alignment: "left",
        },
        {
          text: [
            { text: "Exámen PAP Normal: ", bold: true },
            {
              text:
                data_embarazo.examen_pap !== null
                  ? data_embarazo.examen_pap
                    ? "SI"
                    : "NO"
                  : "-",
            },
          ],
          alignment: "left",
        },
      ],
    },
  ];

  if (data_embarazo.estado === "A" || data_embarazo.estado === "F") {
    tabla_embarazo.push([
      {
        margin: [0, 5],
        fontSize: 10,
        columns: [
          {
            text: [
              { text: "Terminación: ", bold: true },
              {
                text:
                  data_embarazo.fin_parto_tipo !== ""
                    ? utils.terminaciones_embarazo.filter((x) => {
                        return x.id === data_embarazo.fin_parto_tipo;
                      })[0].nombre
                    : "-",
              },
            ],
            alignment: "left",
          },
          {
            text: [
              { text: "Fecha Terminación: ", bold: true },
              {
                text: utils.displayFecha(
                  utils.formatFecha(data_embarazo.fin_parto_fecha)
                ),
              },
            ],
            alignment: "left",
          },
          {
            text: [
              { text: "¿Nacido Vivo?: ", bold: true },
              {
                text:
                  data_embarazo.fin_parto_nacido_vivo !== null
                    ? data_embarazo.fin_parto_nacido_vivo
                      ? "SI"
                      : "NO"
                    : "-",
              },
            ],
            alignment: "left",
          },
        ],
      },
      {
        margin: [0, 5],
        fontSize: 10,
        columns: [
          {
            text: [
              { text: "Sexo RN: ", bold: true },
              {
                text:
                  data_embarazo.fin_parto_sexo !== ""
                    ? data_embarazo.fin_parto_sexo
                    : "-",
              },
            ],
            alignment: "left",
          },
          {
            text: [
              { text: "Peso RN: ", bold: true },
              {
                text:
                  data_embarazo.fin_parto_peso !== null
                    ? data_embarazo.fin_parto_peso + " Kg."
                    : "-",
              },
            ],
            alignment: "left",
          },
          {
            text: [
              { text: "Patologías RN: ", bold: true },
              {
                text:
                  data_embarazo.fin_parto_patologia !== null
                    ? data_embarazo.fin_parto_patologia
                    : "-",
              },
            ],
            alignment: "left",
          },
        ],
      },
    ]);
  }

  let tabla_consultas = {};

  if (consultas.length > 0) {
    tabla_consultas = {
      table: {
        headerRows: 1,
        widths: ["*", "auto", "auto", "auto", "auto", "auto", "auto", "auto"],
        body: [consultas_header].concat(consultas),
      },
    };
  } else {
    tabla_consultas = {
      text: "No hay consultas",
    };
  }

  let header = "";
  let footer = "";
  let content = [
    {
      text: "Ficha Obstétrica",
      style: "title",
      alignment: "left",
      margin: [0, 20],
    },
    commonData(data_paciente, antecedentes, antecedentes_embarazo),
    {
      text: `Datos Embarazo #${number_embarazo}`,
      fontSize: 13,
      bold: true,
      color: "#7987a1",
      alignment: "left",
      margin: [0, 10],
    },
    tabla_embarazo,
    {
      text: "Consultas Embarazo",
      fontSize: 11,
      bold: true,
      color: "#7987a1",
      alignment: "left",
      margin: [0, 10],
    },
    tabla_consultas,
  ];

  let style = {
    promedios: {
      fontSize: 12,
    },
    textCertifico: {
      alignment: "justify",
      margin: [0, 20],
    },
  };

  makeDocument(header, footer, content, style);
};

const fichaGeneral = (
  data_paciente,
  data_consultas,
  antecedentes,
  antecedentes_embarazo,
  callback
) => {
  let tabla_consultas = [];

  if (data_consultas.length > 0) {
    tabla_consultas = data_consultas.map((e) => {
      return [
        {
          text: utils.displayFecha(e.fecha),
          bold: true,
          size: 10,
          margin: [0, 5],
        },
        {
          margin: [0, 5],
          text: [
            { text: "Motivo: ", bold: true, fontSize: 9 },
            { text: e.motivo, fontSize: 9 },
          ],
        },
        {
          margin: [0, 5],
          text: [
            { text: "Diagnóstico: ", bold: true, fontSize: 9 },
            { text: e.diagnostico, fontSize: 9 },
          ],
        },
        {
          margin: [0, 5],
          text: [
            { text: "Indicaciones: ", bold: true, fontSize: 9 },
            { text: e.indicacion, fontSize: 9 },
          ],
        },
        {
          margin: [0, 5],
          text: [
            { text: "Observaciones: ", bold: true, fontSize: 9 },
            { text: e.observaciones, fontSize: 9 },
          ],
        },
        {
          margin: [0, 5],
          text: [
            { text: "Médico: ", bold: true, fontSize: 9 },
            {
              text: "Dr. " + e.medico_apellido + ", " + e.medico_nombres,
              fontSize: 9,
            },
          ],
        },
        {
          margin: [0, 5],
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 5,
              x2: 500,
              y2: 5,
              lineWidth: 0.5,
            },
          ],
        },
      ];
    });
  } else {
    tabla_consultas = { text: "No hay Consultas", fontSize: 9 };
  }
  let header = "";
  let footer = "";
  let content = [
    {
      text: "Ficha Médica",
      style: "title",
      alignment: "left",
      margin: [0, 20],
    },
    commonData(data_paciente, antecedentes, antecedentes_embarazo),
    {
      text: "Consultas",
      fontSize: 11,
      bold: true,
      color: "#7987a1",
      alignment: "left",
      margin: [0, 10],
    },
    tabla_consultas,
  ];

  let style = {
    promedios: {
      fontSize: 12,
    },
    textCertifico: {
      alignment: "justify",
      margin: [0, 20],
    },
  };

  makeDocument(header, footer, content, style);
};

export { fichaObstetricia, fichaGeneral };
